import { type HttpBadStatusCodeError, type UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from '@/packages/query-state/shared/store/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.HiddenObjects__V1_HideOfferWebsite];

export const getQueryKey = (): QueryKey => [EQueryKeys.HiddenObjects__V1_HideOfferWebsite];
